function Loading () {
    return (
        <div className="z-50 fixed flex h-screen w-full flex-col items-center justify-center bg-opacity-50 bg-black">
            <span className="italic text-white-100 animate-pulse">
                Buscando dados...
            </span>
        </div>
    )
}

export default Loading